// Module
var code = `<div id="schedule-calendar-wrapper">
  <!-- Schedule Calendar Modal -->
  <!-- The .modal element itself acts as the backdrop (covers full viewport). -->
  <!-- Uses ng-mousedown instead of ng-click to prevent FullCalendar drag releases -->
  <!-- from triggering close: mousedown target is always where the press started, -->
  <!-- unlike click which fires on the common ancestor of mousedown/mouseup targets. -->
  <div class="modal fade calendar-modal-backdrop" ng-class="{'show': \$ctrl.modalManager.showCalendarModal}"
    ng-style="{'display': \$ctrl.modalManager.showCalendarModal ? 'block' : 'none'}"
    ng-mousedown="\$ctrl.handleBackdropMouseDown(\$event)" tabindex="-1" role="dialog"
    aria-labelledby="scheduleCalendarModalLabel" ng-attr-aria-hidden="{{!\$ctrl.modalManager.showCalendarModal}}">
    <div class="modal-dialog modal-xl modal-dialog-max" role="document" ng-mousedown="\$event.stopPropagation()"
      ng-click="\$event.stopPropagation()">
      <div class="modal-content modal-content-full">
        <div class="modal-body modal-body-flex">
          <div class="schedule-calendar-container">
            <div id="schedule-calendar" class="fullcalendar-container"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Nested modals for calendar functionality -->
  <event-edit-modal show="\$ctrl.modalManager.showEditModal" event="\$ctrl.stateManager.editingEvent"
    on-close="\$ctrl.closeEventEditModal()" on-save="\$ctrl.saveEventEdit(\$event)" on-delete="\$ctrl.deleteEvent(\$event)">
  </event-edit-modal>
  <overlap-conflict-modal show="\$ctrl.modalManager.showOverlapConflictModal"
    conflict="\$ctrl.conflictManager.overlapConflict" on-close="\$ctrl.closeOverlapModal(true)"
    on-resolve="\$ctrl.resolveOverlapConflict(\$conflict)">
  </overlap-conflict-modal>
  <create-interval-modal show="\$ctrl.modalManager.showCreateModal" interval="\$ctrl.stateManager.creatingInterval"
    available-playlists="\$ctrl.stateManager.availableSceneCollections" on-close="\$ctrl.closeCreateIntervalModal()"
    on-create="\$ctrl.createInterval(\$interval)">
  </create-interval-modal>
</div>`;
// Exports
export default code;